export const Events = "Events";
export const EventsEdit = "Events.edit";
